module.exports = __webpack_public_path__ + "img/talkButton.43633ba9.png";